import type { SelectOption } from '..';
import type { SingleValue } from 'react-select';

const getSelectOption = (option: unknown) => {
  const typedOption = option as SingleValue<SelectOption>;
  return typedOption;
};

export const getSelectStringValue = (option: unknown) => {
  const typedOption = getSelectOption(option);
  if (!typedOption) return null;
  const value = typedOption.value;
  if (typeof value === 'number') return value.toString();
  if (typeof value === 'string') return value;
  else return null;
};

export const getSelectNumericValue = (option: unknown) => {
  const typedOption = getSelectOption(option);
  if (!typedOption) return null;
  const value = typedOption.value;
  if (typeof value === 'string') {
    const numericValue = Number(value);
    if (isNaN(numericValue)) return null;
    return numericValue;
  }
  if (typeof value === 'number') return value;
  return null;
};
